var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.company != null)?_c('b-card',[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"mt-2"},[_c('FrameworkAgreementSeller',{on:{"save-requested":_vm.submit}})],1)]),_c('br')]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }